/** @format */

import { defineStore, StoreDefinition } from 'pinia';
import { debounce } from '@power/utils';
import { store } from '@/store';
import { getBaseInfo } from '@/api/global';

const onClickBack = () => {
	//console.log('history.length', history.length);
	//默认展示返回按钮，以下情况不展示返回按钮 用户点击返回键的时候调用uni.navigateBack
	if (window.location.href.indexOf('/menu?') > -1 || window.location.href.indexOf('/my-systems') > -1) {
		top?.uni?.navigateBack();
		return;
	}
	window.top?.history.go(-1);
};

interface GlobalState {
	baseInfo: any;
	curTabbarMenu: Array<any>;
	tabbar: {
		active: number | null;
	};
	navigationBar: {
		title: string;
		leftText: string;
		leftArrow: boolean;
		onClickBack: Function;
	};
}

export const useMoGlobalStore: StoreDefinition = defineStore({
	id: 'p-components-moglobal',
	state: (): GlobalState => ({
		curTabbarMenu: [],
		tabbar: {
			active: 0,
		},
		navigationBar: {
			title: '',
			leftText: '',
			leftArrow: true,
			onClickBack,
		},
		baseInfo: {
			key: 'localData',
			key2: 'localData2',
			key3: 'localData3',
		},
	}),
	getters: {
		mBaseInfo(): any {
			return this.baseInfo;
		},
	},
	actions: {
		setCurTabbarMenu(curTabbarMenu, onChange) {
			this.curTabbarMenu = curTabbarMenu;
			onChange && onChange(0);
		},
		setTabbarActive(tabbarActive) {
			this.tabbar.active = tabbarActive;
		},
		setNavigationBarTitle(navigationBarTitle) {
			this.navigationBar.title = navigationBarTitle;
		},
		setNavigationBar(navigationBar = {}) {
			this.setNavigationBarDebounce(navigationBar, this);
		},
		setNavigationBarDebounce: debounce((navigationBar = {}, _that) => {
			//console.log('doSetNavigationBar', navigationBar);
			_that.doSetNavigationBar(navigationBar);
		}, 100),
		doSetNavigationBar(navigationBar = {}) {
			const { onClickBack: _customOnClickBack, leftArrow: customLeftArrow } = navigationBar;
			//console.log('customOnClickBack', customOnClickBack);

			let leftArrow = true;
			//默认展示返回按钮，以下情况不展示返回按钮
			if (window.location.href.indexOf('hideLeftArrow=1') > -1 || window.location.href.indexOf('/my-systems') > -1) {
				leftArrow = false;
			}
			this.navigationBar = {
				...this.navigationBar,
				...navigationBar,
				leftArrow: customLeftArrow ? customLeftArrow : leftArrow,
				onClickBack,
			};
		},
		setBaseInfo(baseInfo) {
			this.baseInfo = baseInfo;
		},
		/** 初始化数据从服务器获取 */
		async initDataFromServer() {
			try {
				{
					const params = {
						_t: new Date().getTime(),
					};
					const res = await getBaseInfo(params);
					this.setBaseInfo(res);
					//console.log('this.mBaseInfo', this.mBaseInfo);
				}
				return true;
			} catch (error) {
				console.log('error', error);
				return Promise.reject(error);
			}
		},
		/** 初始化基础数据 */
		async initData() {
			try {
				return await this.initDataFromServer();
			} catch (error) {
				console.log('error', error);
				return Promise.reject(error);
			}
		},
	},
});

// 在组件setup函数外使用
export function useMoGlobalStoreWithOut(): any {
	return useMoGlobalStore(store);
}
